import { useMutation, useQueryClient } from '@tanstack/react-query';
import { METHOD, sendJSONRequest } from '@/state/http-request.helpers.ts';
import { useAuth } from '@clerk/clerk-react';
import type { EventDto } from '@/types/dtos/events/response/event.dto.ts';
import { GET_EVENTS_QUERY_KEY } from '../../queries/events/use-events.ts';

export const useCopyEventMutation = () => {
  const { getToken } = useAuth();
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async (id: string) => {
      const token = await getToken();
      return copyEvent(id, token ?? '');
    },
    onSuccess: () => {
      return queryClient.invalidateQueries({
        queryKey: [GET_EVENTS_QUERY_KEY],
      });
    },
  });
};

const copyEvent = async (id: string, token: string): Promise<EventDto> => {
  const url = `${import.meta.env.VITE_API_URL}/events/${id}/copy`;
  return sendJSONRequest({ url, method: METHOD.POST, token });
};

export default useCopyEventMutation;
